import { TakePicture } from '~/components';
import { MaskType } from '~/utils';

interface CreditSimulationSelfieProps {
  handleSubmit: (image: string) => Promise<void>;
}

const CreditSimulationSelfie = ({
  handleSubmit,
}: CreditSimulationSelfieProps) => {
  return <TakePicture handleSubmit={handleSubmit} maskType={MaskType.FACE} />;
};

export default CreditSimulationSelfie;
